import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";

import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

import VueSelect from "vue-select";
import StarRating from "vue-star-rating";
import Spinner from "vue-simple-spinner";

import DropDown from "./components/Dropdown.vue";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */
const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    Vue.component("l-map", LMap);
    Vue.component("l-tile-layer", LTileLayer);
    Vue.component("l-marker", LMarker);
    Vue.component("star-rating", StarRating);
    Vue.component("v-select", VueSelect);
    Vue.component("vue-simple-spinner", Spinner);

    delete Icon.Default.prototype._getIconUrl;

    Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png")
    });
  }
};

export default GlobalComponents;
